/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flow_Collection_1Inputs */

const en_flow_collection_1 = /** @type {(inputs: Flow_Collection_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A brand builds its linesheet in Atelier.`)
};

/**
* | output |
* | --- |
* | "A brand builds its linesheet in Atelier." |
*
* @param {Flow_Collection_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const flow_collection_1 = /** @type {((inputs?: Flow_Collection_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flow_Collection_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_flow_collection_1(inputs)
});